function u(r, n) {
  if (r in n) {
    var e = n[r];
    for (var _len = arguments.length, a = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      a[_key - 2] = arguments[_key];
    }
    return typeof e == "function" ? e.apply(void 0, a) : e;
  }
  var t = new Error("Tried to handle \"".concat(r, "\" but there is no handler defined. Only defined handlers are: ").concat(Object.keys(n).map(function (e) {
    return "\"".concat(e, "\"");
  }).join(", "), "."));
  throw Error.captureStackTrace && Error.captureStackTrace(t, u), t;
}
export { u as match };